module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"current":"Current","other":"Other","city":"City","postalCode":"Postal Code","secondary":"Secondary","streetAddress":"Street Address"},"fr":{"current":"Courante","other":"Autre","city":"Ville","postalCode":"Code postal","secondary":"Secondaire","streetAddress":"Nom de rue"}}')
  delete Component.options._Ctor
}
